import { ValidationModel, ValidationType } from "@/services/validation/types";

export const propertiesValidators = {
    url: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.URL }
        ]
    } as ValidationModel,
    rankStart: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }

        ]
    } as ValidationModel,
    rankEnd: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 },
            { type: ValidationType.Max, value: 100000 }
        ]
    } as ValidationModel,
    reloadTime: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 0 }
        ]
    } as ValidationModel,
    sorting: {
        rules: [
            { type: ValidationType.Required }
        ]
    } as ValidationModel
};
